import { useMutateMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';
interface Props {
  assortmentId: number;
}

export function useMultateRecalculateTotalFile(
  { assortmentId }: Props,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, void>({
    method: 'POST',
    url: () =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.export.recalculate.getFullLinkPath({ assortmentId }),
      }),
    token,
    ...queryOptions,
  });
}
